import type { StorageNode } from '@d/sdk'
import { StorageNodeTypeEnum } from '@d/sdk'
import { fileTypes, Mime } from '@d/util'
import { mdiBookshelf, mdiCloudOutline, mdiFolderOpenOutline, mdiSortAlphabeticalAscending, mdiSortAlphabeticalDescending, mdiSortAscending, mdiSortDescending, mdiTrashCanOutline } from '@mdi/js'
import { markRaw } from 'vue'
import { SortOption } from './sort'

export const sortIcons: Record<string, string> = markRaw({
  [SortOption.TypeAsc]: mdiSortAscending,
  [SortOption.TypeDesc]: mdiSortDescending,
  [SortOption.AlphaNumericAsc]: mdiSortAlphabeticalAscending,
  [SortOption.AlphaNumericDesc]: mdiSortAlphabeticalDescending,
})

export function icon(node: StorageNode, root?: boolean): string {
  if (node.type === StorageNodeTypeEnum.File) {
    return fileTypes[node.mime ?? Mime.raw]?.icon ?? fileTypes.raw!.icon!
  }
  else if (node.type === StorageNodeTypeEnum.Manual) {
    return mdiBookshelf
  }
  else if (node.type === StorageNodeTypeEnum.Bin) {
    return mdiTrashCanOutline
  }
  else if (root) {
    return mdiCloudOutline
  }
  else {
    return mdiFolderOpenOutline
  }
}
export function iconByMime(mime: Mime): string {
  return fileTypes[mime]?.icon ?? fileTypes.raw!.icon!
}
